import { Directive, ElementRef } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';

@Directive({
  selector: '[emsClientNamePatterncheck]',
  providers: [
    {provide: NG_VALIDATORS, useExisting: ClientNamePatterncheckDirective, multi: true}
  ]
})
export class ClientNamePatterncheckDirective {

  newExp: any;

  constructor(public el: ElementRef) {
  }

  validate() {
    this.newExp = new RegExp('^[a-zA-Z0-9+_()\[\\],.\\- &\'/]*$');
    const elementVal = this.el.nativeElement.value;
    if (this.newExp.test(elementVal)) {
      return null;
    } else {
      return {
        clientNameValidation: false
      };
    }
  }

}
